import { Component, OnInit } from '@angular/core';
import { Navbar } from './app-navbar';
import { NAVBARS } from './app-navbars';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit {
  title = '合肥禅生半导体有限公司（NSST）';
  navbar={ id: 1, name: '首页' };
  testMessage = 'Windstorm';
  navbars = NAVBARS;
  selectedNavbar:Navbar; 
  constructor() { } 
  ngOnInit() {
  }
 
  onSelect(navbar: Navbar): void {
    this.selectedNavbar = navbar;
  }
}